// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var ItemTypes = {
    CARD: "card",
};
export var UserActionTypes = {
    COMMUNICATION: "communication",
    EDIT: "edit",
    DELETE: "delete",
    PASSWORD: "password",
    MANUAL_VERIFICATION: "manual_verification",
    VOTER_INFORMATION_LETTER: "voter_information_letter",
    LOGS: "logs",
};
